import { render, staticRenderFns } from "./forumVendors.vue?vue&type=template&id=52c35d60"
import script from "./forumVendors.vue?vue&type=script&lang=js"
export * from "./forumVendors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports